<template>
  <div class="row mb-2">
    <div class="col-sm-5">
      <h4 class="bold w3-text-red size14">
        PENDING LIQUIDATION ({{ fundcode }})
      </h4>
    </div>
    <div class="col-sm-7">
      <div class="w3-right mb-2 ml-2">
        <DateRangeFilter @gettransactions="getTransactions" />
      </div>
    </div>
  </div>
  <div v-if="fetching">
    <img class="mr-3" src="base/img/loading.gif" width="40" />
    Loading transactions
  </div>
  <div v-else>
    <TransactionsTable
      v-if="Transactions"
      :tableid="'redm-table-' + fundcode"
      :headers="TableHeader"
      :rows="Transactions"
    />
  </div>
</template>
<script>
import { useStore } from "vuex";
import { onBeforeMount, ref, toRef } from "vue";
import TransactionsTable from "@/components/TransactionsTable";
import DateRangeFilter from "@/components/DateRangeFilter";
import axios from "axios";
export default {
  components: { TransactionsTable, DateRangeFilter },
  props: ["fundcode", "linkedaccount"],
  setup(props) {
    const store = useStore();
    const fetching = ref(false);
    const Transactions = ref([]);
    const SubAccount = toRef(props, "linkedaccount");
    const FundCode = toRef(props, "fundcode");

    const Period = ref({
      StartDate: "",
      EndDate: "",
    });
    const TransactionALLHistory = () => {
      if (SubAccount.value.SubAccountCode) {
        fetching.value = true;
        axios({
          method: "get",
          url: "/api/Investment/RedemptionALLHistory",
          params: {
            FundCode: FundCode.value,
            SubAccountCode: SubAccount.value.SubAccountCode,
            StartDate: Period.value.StartDate ?? "",
            EndDate: Period.value.EndDate ?? "",
          },
        })
          .then((response) => {
            fetching.value = false;
            if (response.data.status === "success") {
              Transactions.value = response.data.result;
            } else {
              if (response.data.result) {
                store.dispatch("showAlert", {
                  message: response.data.result,
                  status: "error",
                  showing: true,
                });
              }
            }
          })
          .catch((error) => {
            store.dispatch("showAlert", {
              title: "Error: " + error.code,
              message: error.message,
              status: "error",
              showing: true,
            });
          })
          .finally(() => {
            fetching.value = false;
          });
      }
    };

    const TableHeader = ref([
      { text: "Redemption Date", value: "RedemptionDate" },
      { text: "Amount", value: "Amount" },
      { text: "Unit Price", value: "UnitPrice" },
      { text: "Unit Quantity", value: "UnitQuantity" },
      { text: "Fund Code", value: "FundCode" },
    ]);

    const getTransactions = (period) => {
      Period.value = period ?? {
        StartDate: "",
        EndDate: "",
      };
      TransactionALLHistory();
    };
    getTransactions();
    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });

    return {
      TableHeader,
      Transactions,
      fetching,
      getTransactions,
      SubAccount,
    };
  },
};
</script>
